import { Component } from '@angular/core';
import { SettingsService } from '../../shared/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {

  constructor (private settingsService: SettingsService) {

    // Initialize datadog RUM
    this.settingsService.initDataDogScriptElement()
      .then(() => {
        settingsService.initDataDogRUM();
      })
      .catch(); // ignore the exceptions here: There is a chance that you might see "ERROR Error: Uncaught (in promise): ChunkLoadError: Loading chunk 1 failed." when datadog script type is set to "text/plain"
  }
}
